import { defineMessages } from 'react-intl';

export default defineMessages({
    covMiscellaneous: {
        id: 'quoteandbind.PCTConsTranAndServLinedirectives.templates.Miscellaneous.Coverages',
        defaultMessage: 'Coverages'
    },
    formMiscellaneous:{
        id: 'quoteandbind.PCTConsTranAndServLinedirectives.templates.Miscellaneous.Endorsements',
        defaultMessage: 'Endorsements'
    }
});